import {
    FETCH_AI_COMMANDS,
    CLEAN_AI_COMMANDS,
    COMMENT_AI_COMMAND,
    DELETE_AI_COMMAND,
    RUN_AI_COMMAND,
} from '../actions/types';
import _ from "lodash";
import {toNumber} from "../functions";

const AI_COMMANDS_DEFAULT_STATE = {};

const AiCommandsReducer = (state = AI_COMMANDS_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_AI_COMMANDS:
            return payload;

        case COMMENT_AI_COMMAND:
            return { ...state, items: _.map(state.items, item => {
                if (toNumber(item.id) === toNumber(payload.id)) {
                    item = { ...item, comment: payload.comment };
                }

                return item;
            }) };

        case RUN_AI_COMMAND:
            return { ...state, items: _.map(state.items, item => {
                if (toNumber(item.id) === toNumber(payload)) {
                    item = { ...item, status: 'waiting' };
                }

                return item;
            }) };

        case CLEAN_AI_COMMANDS:
        case DELETE_AI_COMMAND:
            return AI_COMMANDS_DEFAULT_STATE;

        default:
            return state;
    }
};

export default AiCommandsReducer;
